import Q from 'q';
import request from 'superagent';
import ACTION_TYPES from '../../constants/actionTypes';
import { showToast } from './misc';
import isEmpty from 'lodash/isEmpty';
import { getErrorMessage } from 'shared/lib/utils';
import moment from 'moment-timezone';

/*
 * Start claim
 * ========================================
 */

export function startClaim() {
  return {
    type: ACTION_TYPES.START_CLAIM,
  };
}

/*
 * Save claims device method
 * ========================================
 */

export function saveIsClaimsDeviceMailedOut(value) {
  return {
    type: ACTION_TYPES.SAVE_CLAIMS_DEVICE_METHOD,
    isDeviceMailedOut: value,
  };
}

/*
 * Claims history
 * ========================================
 */

function getClaimsHistoryRequest() {
  return {
    type: ACTION_TYPES.GET_CLAIMS_HISTORY,
  };
}

function getClaimsHistorySuccess(claims) {
  return {
    type: ACTION_TYPES.GET_CLAIMS_HISTORY_SUCCESS,
    claims,
  };
}

function getClaimsHistoryFailure(error) {
  return {
    type: ACTION_TYPES.GET_CLAIMS_HISTORY_FAILURE,
    error,
  };
}

function shouldGetClaimsHistory(state) {
  return (
    !state.claimsHistoryFetchedAt ||
    moment().diff(moment(state.claimsHistoryFetchedAt), 'hours') > 1
  );
}

export function getClaimsHistory() {
  return (dispatch, getState) => {
    const deferred = Q.defer();

    if (shouldGetClaimsHistory(getState())) {
      dispatch(getClaimsHistoryRequest());
      request
        .get(`${process.env.REACT_APP_SURE_API_BASE_URL}/api/user/v2/claims`)
        .set('Authorization', `Bearer ${getState().authToken}`)
        .end((err, response) => {
          if (err) {
            const errMessage = getErrorMessage(err);
            dispatch(getClaimsHistoryFailure(errMessage));
            deferred.reject(errMessage);
            dispatch(showToast(errMessage, 'error'));
          } else {
            dispatch(getClaimsHistorySuccess(response.body));
            deferred.resolve(response.body);
          }
        });
    } else {
      deferred.resolve();
    }
    return deferred.promise;
  };
}

/*
 * Claims process
 * ========================================
 */

function getClaimsProcessRequest() {
  return {
    type: ACTION_TYPES.GET_CLAIMS_PROCESS,
  };
}

function getClaimsProcessSuccess(process) {
  return {
    type: ACTION_TYPES.GET_CLAIMS_PROCESS_SUCCESS,
    process,
  };
}

function getClaimsProcessFailure(error) {
  return {
    type: ACTION_TYPES.GET_CLAIMS_PROCESS_FAILURE,
    error,
  };
}

export function getClaimsProcess(policyNumber) {
  return (dispatch, getState) => {
    const deferred = Q.defer();

    dispatch(getClaimsProcessRequest());
    request
      .post(
        `${process.env.REACT_APP_SURE_API_BASE_URL}/api/user/v2/claims/process`
      )
      .send({ policy_number: policyNumber })
      .set('Authorization', `Bearer ${getState().authToken}`)
      .end((err, response) => {
        if (isEmpty(response.body)) {
          const errMessage = 'No claims process found';
          dispatch(getClaimsProcessFailure(errMessage));
          deferred.reject(errMessage);
        } else if (err) {
          const errMessage = getErrorMessage(err);
          dispatch(getClaimsProcessFailure(errMessage));
          deferred.reject(errMessage);
        } else {
          dispatch(getClaimsProcessSuccess(response.body));
          deferred.resolve(response.body);
        }
      });

    return deferred.promise;
  };
}

/*
 * Claims device
 * ========================================
 */

export function saveClaimsDeviceDamages(damages) {
  return {
    type: ACTION_TYPES.SAVE_CLAIMS_DEVICE_DAMAGES,
    damages,
  };
}

export function saveClaimsDeviceDamageDescription(description) {
  return {
    type: ACTION_TYPES.SAVE_CLAIMS_DEVICE_DAMAGE_DESCRIPTION,
    description,
  };
}

export function saveClaimsDeviceSerialNumber(serialNumber) {
  return {
    type: ACTION_TYPES.SAVE_CLAIMS_DEVICE_SERIAL_NUMBER,
    serialNumber,
  };
}

/*
 * Submit claims
 * ========================================
 */

function submitClaimRequest() {
  return {
    type: ACTION_TYPES.SUBMIT_CLAIM,
  };
}

function submitClaimSuccess(data) {
  return {
    type: ACTION_TYPES.SUBMIT_CLAIM_SUCCESS,
    data,
  };
}

function submitClaimFailure(error) {
  return {
    type: ACTION_TYPES.SUBMIT_CLAIM_FAILURE,
    error,
  };
}

export function submitClaim(details) {
  return (dispatch, getState) => {
    const deferred = Q.defer();

    const {
      claimsProcessId,
      claimsDeviceDamages,
      claimsDeviceDamageDescription,
      claimsDeviceSerialNumber,
      isClaimsDeviceMailedOut,
    } = getState();

    const payload = {
      policy_number: details.policyNumber,
      claim_process_id: claimsProcessId,
      bank_account_id: details.bankAccountId,
      vertical_code: details.verticalCode,
      details: {
        device_id: claimsDeviceSerialNumber,
        claim_description: claimsDeviceDamageDescription,
        damages: claimsDeviceDamages,
        is_device_mailed_out: isClaimsDeviceMailedOut,
      },
    };

    dispatch(submitClaimRequest());
    request
      .post(`${process.env.REACT_APP_SURE_API_BASE_URL}/api/user/v2/claims`)
      .send(payload)
      .set('Authorization', `Bearer ${getState().authToken}`)
      .end((err, response) => {
        if (err) {
          const errMessage = getErrorMessage(err);
          dispatch(submitClaimFailure(errMessage));
          deferred.reject(errMessage);
          dispatch(showToast(errMessage, 'error'));
        } else {
          dispatch(submitClaimSuccess(response.body));
          deferred.resolve(response.body);
        }
      });

    return deferred.promise;
  };
}
